module.exports = __webpack_public_path__ + "e4d40c6c0f209b871da346b50af068a2.svg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../components/Footer/logos/karin-und-uwe-hollweg-stiftung.svg
// module id = 937
// module chunks = 0